module.exports = __webpack_public_path__ + "static/media/por7o.3862ba85.jpg";